import React from 'react';
import AssetsList from './components/AssetsList';

// Digital Assets Page Component
const DigitalAssetsPage: React.FC = () => {
  return (
    <div className="container-fluid">
      <AssetsList />
    </div>
  );
};

export default DigitalAssetsPage;

